import { sendWebsocketMessage } from '../../../../../App';

// NOTE we are sending them, but are we updating them locally? I'm not seeing a new value in the store: useUserPreferences().tradePlanConfig.evaluateQuotes
let prevMessage = '';
export function sendUserPreferences(userPreferences) {
  const msg = {
    messageType: 'updateUserPreferences',
    json: userPreferences,
  };
  const compareMsg = JSON.stringify(msg);
  if (prevMessage === compareMsg) {
    return;
  } else {
    prevMessage = msg;
  }
  sendWebsocketMessage(msg);
}
